export default __webpack_public_path__ + "static/media/ev-8h.9ab32f7b.png";